/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VatExemptionModel } from '../../models/vat-exemption-model';
import { VatExemptionUpdateModel } from '../../models/vat-exemption-update-model';

export interface PutApiVatexemptionV1Id$Json$Params {
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: VatExemptionUpdateModel
}

export function putApiVatexemptionV1Id$Json(http: HttpClient, rootUrl: string, params: PutApiVatexemptionV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<VatExemptionModel>> {
  const rb = new RequestBuilder(rootUrl, putApiVatexemptionV1Id$Json.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VatExemptionModel>;
    })
  );
}

putApiVatexemptionV1Id$Json.PATH = '/private/v1/vat-exemptions/{id}';
